<template>
  <v-main class="tpadding">
    <v-container fluid>
      <v-card class="rounded-xl elevation-5">
        <v-toolbar dense dark color="pinkKonect" elevation="2">
          <v-toolbar-title>Viajes Konect Van Empresarial</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            small
            center
            text
            :loading="loading"
            class="ma-auto ml-3"
            elevation="0"
            @click="reportPdf('reports')"
          >
            Descargar PDF
            <v-icon right>mdi-file-pdf-box</v-icon>
          </v-btn>
          <v-btn :disabled="items == 0" elevation="0" text small :loading="loadingReports">
            <xlsx-workbook>
              <xlsx-sheet :collection="sheet.data" v-for="sheet in sheetsGeneral" :key="sheet.name" :sheet-name="sheet.name" />
              <xlsx-download :filename="'Reporte ' + this.reportTypeGeneral + '.xlsx'">
                <button>DESCARGAR</button>
                <v-icon right>mdi-microsoft-excel</v-icon>
              </xlsx-download>
            </xlsx-workbook>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row no-gutters class="pb-4" style="justify-content: space-between">
            <v-col sm="9" style="align-self: center; display: flex; flex-direction: column">
              <v-row>
                <v-col cols="2" style="display: flex; align-items: flex-end">
                  <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date"
                        dense
                        label="Fecha de inicio"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" :min="this.allowedDates" scrollable locale="es">
                      <v-spacer></v-spacer>
                      <v-btn text @click="modal = false"> Cancelar </v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(date)"> Aceptar </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="2" style="display: flex; align-items: flex-end">
                  <v-dialog ref="dialog2" v-model="modal2" :return-value.sync="date2" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date2"
                        dense
                        label="Fecha fin"
                        hide-details
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date2" :min="date" scrollable locale="es">
                      <v-spacer></v-spacer>
                      <v-btn text @click="modal2 = false"> Cancelar </v-btn>
                      <v-btn text color="primary" @click="$refs.dialog2.save(date2)"> Aceptar </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    v-model="state"
                    :disabled="loading"
                    multiple
                    append-icon="mdi-chevron-down"
                    item-value="idruta_externo"
                    item-text="name"
                    label="Rutas"
                    :items="routes"
                    hide-details
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @mousedown.prevent @click="toggle">
                        <v-list-item-action>
                          <v-icon :color="state.length > 0 ? 'indigo darken-4' : ''">
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title> Todas las rutas </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.name }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text text-caption"> (+{{ state.length - 1 }} mas) </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="4" class="pt-0" style="display: flex; align-items: flex-end">
                  <v-text-field class="pt-0" v-model="search" onlyRead label="Buscar" single-line hide-details clearable></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col sm="3" style="text-align: right; margin-top: 21px">
              <v-btn
                small
                center
                outlined
                :loading="loading"
                color="blueKonect"
                class="ma-auto ml-3"
                elevation="0"
                @click="openTransactions()"
              >
                Transacciones
              </v-btn>
              <v-btn
                small
                center
                outlined
                :disabled="items == ''"
                color="blueKonect"
                class="ma-auto mx-3"
                elevation="0"
                @click="getReports()"
              >
                Reportes
              </v-btn>
              <v-btn
                small
                center
                outlined
                :loading="loading"
                :disabled="date == '' || date2 == ''"
                color="blueKonect"
                class="ma-auto"
                elevation="0"
                @click="refresh()"
              >
                Consultar
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="search"
            :items-per-page="5"
            loading-text="Cargando registros... Porfavor espere"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              itemsPerPageAllText: 'Todos',
            }"
          >
            <template v-slot:[`item.ruta`]="{ item }">
              {{ item.ruta ? item.ruta.nombre_ruta + " - " + item.tipo_viaje : "" }}
            </template>
            <template v-slot:[`item.numero_economico`]="{ item }">
              {{ item.vehiculo ? item.vehiculo.numero_economico : "" }}
            </template>
            <template v-slot:[`item.usuario`]="{ item }">
              {{ item.usuario ? item.usuario.nombre + " " + item.usuario.apellido_paterno + " " + item.usuario.apellido_materno : "" }}
            </template>
            <template v-slot:[`item.viaje_usuario_van`]="{ item }">
              {{ item.viaje_usuario_van.length > 0 ? item.viaje_usuario_van[0].estado.estados_viaje.codigo : "" }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <infoBtn v-if="permisos.includes('VAN_AGREGA_VIAJE_EMPRESARIAL_ESCRITURA') && item.estado_externo == 'FINALIZADO'" 
                :icon="'mdi-account-plus-outline'" :actionColor="'primary'" :text="'Agregar Pasajeros'" :data="item" :onClick="openDialogAddPassangers" />
              <infoBtn :icon="'mdi-eye'" :actionColor="'primary'" :text="'Detalle'" :data="item" :onClick="view" />
            </template>
            <template v-slot:[`footer.page-text`]="props">
              Página {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-data> No hay información disponible </template>
            <template v-slot:no-results> No se obtuvieron resultados </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-dialog v-model="dialogs.reports" persistent scrollable max-width="80%" class="up">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title v-text="'Tipo de reportes'" />
          </v-toolbar>
          <v-card-text class="py-6" style="height: 80vh">
            <div class="text-h5 mb-4">{{ "Selecciona algún reporte" }}</div>
            <v-btn-toggle v-model="toogleBtn" color="primary" mandatory>
              <v-btn
                small
                value="1"
                center
                outlined
                :color="toogleBtn == '1' ? 'pinkKonect' : 'blueKonect'"
                :disabled="items == ''"
                class="ma-auto mx-3"
                elevation="0"
                @click="reportRuta()"
              >
                Reporte de rutas
              </v-btn>
              <!-- <v-btn small value="2" center outlined :color="toogleBtn == '2' ? 'pinkKonect' : 'blueKonect'" :disabled="items == ''" class="ma-auto mx-3" elevation="0" @click="reportVehiculo()">
                Reporte de vehiculos
              </v-btn> -->
              <v-btn
                small
                value="3"
                center
                outlined
                :color="toogleBtn == '3' ? 'pinkKonect' : 'blueKonect'"
                :disabled="items == ''"
                class="ma-auto mx-3"
                elevation="0"
                @click="reportViajes()"
              >
                Reporte de viajes
              </v-btn>
              <v-btn
                small
                value="4"
                center
                outlined
                :color="toogleBtn == '4' ? 'pinkKonect' : 'blueKonect'"
                :disabled="items == ''"
                class="ma-auto mx-3"
                elevation="0"
                @click="reportUtilizacion()"
              >
                Reporte de utilización
              </v-btn>
            </v-btn-toggle>
            <v-data-table
              v-if="itemsDetail.length > 0"
              :headers="headersDetail"
              :items="itemsDetail"
              item-key="id"
              class="elevation-1 ma-6 mt-6"
              :footer-props="{
                'items-per-page-text': 'Elementos por página',
                'items-per-page-options': [5, 10, 50],
                itemsPerPageAllText: 'Todos',
              }"
            >
              <template v-slot:no-data> No hay información disponible </template>
              <template v-slot:no-results> No se obtuvieron resultados </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              center
              outlined
              color="blue"
              :loading="loading"
              class="ma-auto ml-3"
              elevation="0"
              @click="reportPdf(reportType)"
            >
              Descargar PDF
              <v-icon right>mdi-file-pdf-box</v-icon>
            </v-btn>
            <v-btn
              v-if="itemsDetail.length > 0"
              color="success"
              elevation="0"
              outlined
              small
              :loading="loadingReports"
              :disabled="itemsDetail.length < 1"
            >
              <xlsx-workbook>
                <xlsx-sheet :collection="sheet.data" v-for="sheet in sheets" :key="sheet.name" :sheet-name="sheet.name" />
                <xlsx-download :filename="'Reporte de ' + this.reportType + '.xlsx'">
                  <button>DESCARGAR</button>
                  <v-icon right>mdi-microsoft-excel</v-icon>
                </xlsx-download>
              </xlsx-workbook>
            </v-btn>
            <Basic-Btn text="Cerrar" color="error" icon="mdi-close" @click="cancel()" :loading="loadingReports" />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogs.transactions" persistent scrollable max-width="80%" class="up">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title v-text="'Transacciones'" />
          </v-toolbar>
          <v-card-text class="py-6" style="height: 80vh">
            <v-row no-gutters class="pb-7" style="justify-content: space-between">
              <v-col sm="10" style="align-self: center; display: flex; flex-direction: column">
                <v-row class="mt-2">
                  <v-col cols="3" style="display: flex; align-items: flex-end">
                    <v-dialog ref="dialog3" v-model="modal3" :return-value.sync="date3" persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date3"
                          dense
                          label="Fecha de inicio"
                          hide-details
                          prepend-inner-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date3" :min="this.allowedDates2" scrollable locale="es">
                        <v-spacer></v-spacer>
                        <v-btn text @click="modal3 = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog3.save(date3)"> Aceptar </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="3" style="display: flex; align-items: flex-end">
                    <v-dialog ref="dialog4" v-model="modal4" :return-value.sync="date4" persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="date4"
                          dense
                          label="Fecha fin"
                          hide-details
                          prepend-inner-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="date4" :min="date3" scrollable locale="es">
                        <v-spacer></v-spacer>
                        <v-btn text @click="modal4 = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog4.save(date4)"> Aceptar </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col cols="6" class="pt-0" style="display: flex; align-items: flex-end">
                    <v-text-field
                      class="pt-0"
                      v-model="searchTransactions"
                      onlyRead
                      label="Buscar"
                      single-line
                      hide-details
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col sm="2" style="text-align: right; margin-top: 21px">
                <v-btn
                  small
                  center
                  outlined
                  :loading="loading"
                  :disabled="date3 == '' || date4 == ''"
                  color="blueKonect"
                  class="ma-auto"
                  elevation="0"
                  @click="getTransactions()"
                >
                  Consultar
                  <v-icon right>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headersTransactions"
              :items="itemsTransactions"
              :loading="loadingReports"
              :search="searchTransactions"
              class="elevation-1 ma-6 mt-6"
              :footer-props="{
                'items-per-page-text': 'Elementos por página',
                'items-per-page-options': [5, 10, 50],
                itemsPerPageAllText: 'Todos',
              }"
            >
              <template v-slot:no-data> No hay información disponible </template>
              <template v-slot:no-results> No se obtuvieron resultados </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              center
              outlined
              color="blue"
              :loading="loading"
              class="ma-auto ml-3"
              elevation="0"
              @click="reportPdf(reportType)"
            >
              Descargar PDF
              <v-icon right>mdi-file-pdf-box</v-icon>
            </v-btn>
            <v-btn
              v-if="itemsTransactions.length > 0"
              color="success"
              elevation="0"
              outlined
              small
              :loading="loadingReports"
              :disabled="itemsTransactions.length < 1"
            >
              <xlsx-workbook>
                <xlsx-sheet :collection="sheet.data" v-for="sheet in sheets" :key="sheet.name" :sheet-name="sheet.name" />
                <xlsx-download :filename="'Reporte de ' + this.reportType + '.xlsx'">
                  <button>DESCARGAR</button>
                  <v-icon right>mdi-microsoft-excel</v-icon>
                </xlsx-download>
              </xlsx-workbook>
            </v-btn>
            <Basic-Btn text="Cerrar" color="error" icon="mdi-close" @click="cancel()" :loading="loadingReports" />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogs.addPassengers" persistent scrollable max-width="70%" class="up">
        <v-card>
          <v-toolbar dense dark color="primary" elevation="2">
            <v-toolbar-title v-text="'Agregar Pasajeros Konect Van Empresarial'" />
          </v-toolbar>
          <v-card-text v-if="selectedTrip" class="py-6" style="height: 80vh">
            <p class="text-h5 mb-2">Folio de viaje seleccionado: {{selectedTrip.folio_orden_servicio}}</p>
            <p class="text-h5 mb-2">Ruta: {{selectedTrip.ruta.nombre_ruta}}</p>
            <p class="text-h5 mb-2">Fecha Hora Inicio: {{selectedTrip.fecha_inicio_plan}}</p>

            <p class="text-h7 mb-2">Pasajeros con viajes finalizados: {{selectedTrip.pasajeros}}</p>
            <p class="text-h7 mb-2">Pasajeros disponibles para agregar: {{selectedTrip.pasajeros_disponibles}}</p>
            <p class="text-h7 mb-2">Porcentaje de uso: {{selectedTrip.porcetaje_uso}}%</p>
          <v-form ref="form">
            <v-autocomplete v-model="tipoSeleccionado" :items="tipos" label="Seleccione un método" @change="changeMethod()"></v-autocomplete>
            <v-text-field v-if="tipoSeleccionado == 'por_porc'" label="Porcetaje" type="number" v-model="valor_porc" :rules="rules.porc"></v-text-field>
            <v-text-field v-if="tipoSeleccionado == 'por_cant'" label="Cantidad" type="number" v-model="valor_cant"  :rules="rules.cant"></v-text-field>
          </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <Basic-Btn text="Cerrar" color="error" icon="mdi-close" @click="cancel()" :loading="loading" />
            <Basic-Btn text="Aceptar" color="green" icon="mdi-close" @click="aceptar()" :loading="loading" />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right style="white-space: pre-line">
        {{ errorList[codeError] }}
        {{ "\n\n" + this.codeError }}
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import services from "@/utils/services";
import { tablek, errormsg, simpleDialog, BasicBtn, infoBtn, csvButton, infoChip } from "@/components";
import moment from "moment";
import errorList from "@/utils/errorsList";
import { mapActions } from "vuex";
import * as _ from "lodash";

import { XlsxWorkbook } from "../../../node_modules/vue-xlsx/dist/vue-xlsx.es";
import { XlsxSheet } from "../../../node_modules/vue-xlsx/dist/vue-xlsx.es";
import { XlsxDownload } from "../../../node_modules/vue-xlsx/dist/vue-xlsx.es";

import downloadjs from 'downloadjs'

export default {
  name: "Clientes",
  components: {
    tablek,
    BasicBtn,
    errormsg,
    simpleDialog,
    csvButton,
    infoBtn,
    infoChip,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data: () => ({
    loading: false,
    loadingReports: false,
    success: false,
    msgSuccess: "",
    allRoutesSelected: false,
    error: false,
    reportType: "",
    reportTypeGeneral: "",
    toogleBtn: 0,
    codeError: "",
    state: [],
    date: "",
    modal: false,
    date2: "",
    modal2: false,
    date3: "",
    modal3: false,
    date4: "",
    modal4: false,
    search: "",
    searchTransactions: "",
    rules: {
      porc: [
        v => !!v || 'El valor es requerido, entre 0 y 100%',
        v => (v >= 0 && v <= 100) || 'La puntuación debe estar entre 0 y 100',
      ],
      cant: [
        v => !!v || 'El valor es requerido',
        v => (v >= 0 && v <= 100) || 'La puntuación debe estar entre 0 y 100',
      ]
    },
    valor_porc: 0,
    valor_cant: 0,
    headers: [
      { text: "Folio de viaje", align: "center", sortable: false, value: "folio_orden_servicio" },
      { text: "Ruta", align: "center", sortable: false, value: "ruta" },
      { text: "Fecha Hora Inicio", align: "center", sortable: false, value: "fecha_inicio_plan" },
      { text: "Fecha Hora Fin", align: "center", sortable: false, value: "fecha_fin_plan" },
      { text: "Número económico", align: "center", sortable: false, value: "numero_economico" },
      { text: "Nombre del operador", align: "center", sortable: false, value: "usuario" },
      { text: "Estado de viaje", align: "center", sortable: false, value: "estado_externo" },
      { text: "Pasajeros con viaje finalizado", align: "center", sortable: false, value: "pasajeros" },
      { text: "Porcenaje de uso", align: "center", sortable: false, value: "porcetaje_uso" },
      { text: "Acciones", align: "center", sortable: false, value: "actions" },
    ],
    items: [],
    headersDetail: [],
    headersTransactions: [],
    itemsDetail: [],
    itemsTransactions: [],
    errorList,
    allowedDates: "",
    allowedDates2: "",
    clients: "",
    routes: [],
    estados_viaje: {
      3: "ENVIADO",
      4: "EN CURSO",
      5: "EN CURSO",
      6: "FINALIZADO",
      7: "FINALIZADO",
      8: "CANCELADO",
    },
    dialogs: {
      transactions: false,
      reports: false,
      addPassengers: false
    },
    selectedTrip: null,
    sheetsGeneral: [],
    sheets: [],
    searchRoutes: null,
    permisos: [],
    tipos: [
      { text: "Por porcentaje", value: "por_porc" },
      { text: "Por cantidad", value: "por_cant" },
    ],
    tipoSeleccionado: "por_porc"
  }),
  activated() {
    var dateFrom = moment(dateFrom).subtract(9, "months").format("YYYY-MM-DD");
    var dateFrom2 = moment(dateFrom2).subtract(9, "months").format("YYYY-MM-DD");
    this.date = moment().format("YYYY-MM-DD");
    this.date2 = moment().format("YYYY-MM-DD");
    this.allowedDates = dateFrom;
    this.allowedDates2 = dateFrom2;
    this.permisos = this.$session.get("permisos");
    this.getRoutes();
    this.refresh();
  },
  computed: {
    isReading: function () {
      return services.check(1, this.$route.path);
    },
    isWriting: function () {
      return services.check(2, this.$route.path);
    },
    allRoutes() {
      return this.state.length === this.routes.length;
    },
    someRoutes() {
      return this.state.length > 0 && !this.allRoutes;
    },
    icon() {
      if (this.allRoutes) return "mdi-close-box";
      if (this.someRoutes) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapActions("konectVan", ["setComponent"]),
    async getRoutes() {
      try {
        this.loading = true;
        const clientsResponse = await this.axios.get(services.routes.clients);
        this.clients = _.uniqWith(clientsResponse.data.data, _.isEqual);

        const routesPromises = this.clients.map((client) => {
          return this.axios.get(services.routes.routesByClient + "/" + client.idcliente_externo);
        });

        const routesResponses = await Promise.all(routesPromises);
        this.routes = [];
        routesResponses.forEach((res) => {
          this.routes = this.routes.concat(res.data.data);
        });

        this.routes.forEach((route) => {
          route.name = route.nombre_ruta + " - " + route.tipo_servicio;
        });
        this.loading = false;
      } catch (error) {
        this.error = true;
        this.codeError = error.response.data.message;
      }
    },
    changeMethod() {
    },
    async aceptar() {
      let data = {};
      this.loading = true;
      if(this.tipoSeleccionado == 'por_porc') {
        data = [{
          idviaje_externo: this.selectedTrip.idviaje_externo,
          porcentaje: parseFloat(this.valor_porc),
        }]
      } else if(this.tipoSeleccionado == 'por_cant') { 
        data = [{
          idviaje_externo: this.selectedTrip.idviaje_externo,
          cantidad: parseFloat(this.valor_cant)
        }]
      }
      try {
        const response = await this.axios.post(services.routes.addUsersToTrip, { data });
        if(response.data.data.errores.length > 0) {
          this.error = true;
          this.codeError = response.data.data.errores[0].message;
        } else {
          this.tipoSeleccionado = "por_porc";
          this.dialogs.addPassengers = false;
          this.valor_porc = 0;
          this.valor_cant = 0;
        }
      } catch (e) {
        this.error = true;
        this.codeError = e.response.data.message;
      } finally {
        this.loading = false;
        this.$refs.form.reset();
        this.refresh();
      }
    },
    refresh() {
      let data;
      if (this.allRoutesSelected) {
        for (let i = 0; i < this.state.length; i++) {
          this.state[i] = this.state[i].idruta_externo;
        }
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      } else {
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      }
      this.loading = true;
      this.axios
        .post(services.routes.van + "/report", { data })
        .then((res) => {
          this.items = res.data.data;
          for (let i = 0; i < this.items.length; i++) {
            this.items[i].fecha_inicio_plan = moment(this.items[i].fecha_inicio_plan).format("DD-MM-YYYY HH:mm");
            this.items[i].fecha_fin_plan = moment(this.items[i].fecha_fin_plan).format("DD-MM-YYYY HH:mm");
            const estado_externo = _.get(this.items[i], "estado_externo", "").toString();
            if (_.has(this.estados_viaje, estado_externo)) {
              this.items[i].estado_externo = this.estados_viaje[estado_externo];
            } else {
              this.items[i].estado_externo = "";
            }
          }
          this.reportTypeGeneral = "General";

          this.sheetsGeneral = [
            {
              name: "Reporte de viaje",
              data: [{}],
            },
          ];
          if (this.items.length > 0) {
            this.sheetsGeneral[0].data.shift();
          }
          for (let i = 0; i < this.items.length; i++) {
            let obj = {
              "Folio de viaje": this.items[i].folio_orden_servicio,
              Ruta: this.items[i].ruta ? this.items[i].ruta.nombre_ruta : "",
              "Fecha Hora Inicio": this.items[i].fecha_inicio_plan,
              "Fecha Hora Fin": this.items[i].fecha_fin_plan,
              "Número económico": this.items[i].vehiculo ? this.items[i].vehiculo.numero_economico : "",
              "Nombre del operador": this.items[i].usuario
                ? this.items[i].usuario.nombre + " " + this.items[i].usuario.apellido_paterno + " " + this.items[i].usuario.apellido_materno
                : "",
              "Estado del viaje": this.items[i].estado_externo,
              "Pasajeros con viaje finalizado": this.items[i].pasajeros,
            };
            this.sheetsGeneral[0].data.push(obj);
          }
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reportPdf(type) {
      let urlReport;
      let nameReport;
      if (type === 'reports') {
        nameReport = 'Reporte de viaje '
        urlReport = services.routes.van + "/report/pdf"
      } else if (type === 'Rutas') {
        nameReport = 'Reporte de Rutas '
        urlReport = services.routes.van + "/report/routes/pdf"
      } else if (type === 'Viajes') {
        nameReport = 'Reporte de Viajes '
        urlReport = services.routes.van + "/report/for/download/pdf"
      } else if (type === 'Utilización') {
        nameReport = 'Reporte de Utilización '
        urlReport = services.routes.van + "/report/transaction/summary/pdf"
      } else if (type === 'Transacciones') {
        nameReport = 'Reporte de Transacciones '
        urlReport = services.routes.van + "/report/transaction/trip/van/pdf"
      }
      
      let data;
      if (this.allRoutesSelected) {
        for (let i = 0; i < this.state.length; i++) {
          this.state[i] = this.state[i].idruta_externo;
        }
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      } else {
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      }
      try {
        this.loading = true;
        this.axios({
          url: urlReport,
          method: 'POST',
          data: {data},
          responseType: 'blob'
        })
        .then((response) => {
            downloadjs(response.data, nameReport + moment().format("MM-DD-YYYY HH:mm") + ".pdf", 'application/pdf');
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.message;
        })
        .finally(() => {
          this.loading = false;
        });
      } catch (error) {
      }
    },
    view(item) {
      this.setComponent({ component: "detail", item });
    },
    cancel() {
      this.toogleBtn = 0;
      this.dialogs.transactions = false;
      this.dialogs.addPassengers = false;
      this.headersTransactions = [];
      this.itemsTransactions = [];
      this.date3 = "";
      this.modal3 = false;
      this.date4 = "";
      this.modal4 = false;
      this.dialogs.reports = false;
      this.itemsDetail = "";
      this.headersDetail = "";
      this.sheets = [];
      this.$refs.form.reset();
    },
    getReports() {
      this.dialogs.reports = true;
      this.reportRuta()
    },
    reportRuta() {
      let data;
      if (this.allRoutesSelected) {
        for (let i = 0; i < this.state.length; i++) {
          this.state[i] = this.state[i];
        }
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      } else {
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      }
      this.reportType = "Rutas";
      this.loadingReports = true;
      this.axios
        .post(services.routes.van + "/report/routes", { data })
        .then((res) => {
          this.headersDetail = [
            { text: "Id ruta", align: "center", sortable: false, value: "idruta" },
            { text: "Tipo de servicio", align: "center", sortable: false, value: "tipo_servicio" },
            { text: "Nombre de ruta", align: "center", sortable: false, value: "nombre_ruta" },
            { text: "Número de paradas", align: "center", sortable: false, value: "numero_paradas" },
            { text: "Parada con mayor ascenso", align: "center", sortable: false, value: "parada_mayor_ascensos" },
            { text: "Parada con mayor descenso", align: "center", sortable: false, value: "parada_mayor_descensos" },
            { text: "Promedio de calificación", align: "center", sortable: false, value: "promedio_calificacion" },
            { text: "Cantidad de pasajeros trasladados", align: "center", sortable: false, value: "cantidad_pasajeros_trasladados" },
          ];
          this.itemsDetail = res.data.data;

          this.sheets = [
            {
              name: "Reporte de rutas",
              data: [{}],
            },
          ];
          if (this.itemsDetail.length > 0) {
            this.sheets[0].data.shift();
          }
          for (let i = 0; i < this.itemsDetail.length; i++) {
            let obj = {
              "Id ruta": this.itemsDetail[i].idruta,
              "Tipo de servicio": this.itemsDetail[i].tipo_servicio,
              "Nombre de ruta": this.itemsDetail[i].nombre_ruta,
              "Número de paradas": this.itemsDetail[i].numero_paradas,
              "Parada con mayor ascenso": this.itemsDetail[i].parada_mayor_ascensos,
              "Parada con mayor descenso": this.itemsDetail[i].parada_mayor_descensos,
              "Promedio de calificación": this.itemsDetail[i].promedio_calificacion,
              "Cantidad de pasajeros trasladados": this.itemsDetail[i].cantidad_pasajeros_trasladados,
            };
            this.sheets[0].data.push(obj);
          }
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.message;
        })
        .finally(() => {
          this.loadingReports = false;
        });
    },
    reportVehiculo() {
      let data;
      if (this.allRoutesSelected) {
        for (let i = 0; i < this.state.length; i++) {
          this.state[i] = this.state[i];
        }
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      } else {
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      }
      this.reportType = "Vehiculos";
      this.loadingReports = true;
      this.axios
        .post(services.routes.van + "/report/vehicle", { data })
        .then((res) => {
          this.headersDetail = [
            { text: "Placas", align: "center", sortable: false, value: "placas" },
            { text: "Número económico", align: "center", sortable: false, value: "numero_economico" },
            { text: "Capacidad", align: "center", sortable: false, value: "capacidad" },
            { text: "Marca", align: "center", sortable: false, value: "marca_chasis" },
            { text: "Modelo", align: "center", sortable: false, value: "marca_carroceria" },
            { text: "Año", align: "center", sortable: false, value: "modelo_chasis" },
            { text: "Número de viajes", align: "center", sortable: false, value: "cantidad_viajes" },
            { text: "Calificación promedio", align: "center", sortable: false, value: "promedio_calificacion" },
            { text: "Nombre del operador", align: "center", sortable: false, value: "nombre" },
            { text: "Número máximo de pasajeros", align: "center", sortable: false, value: "max_pasajeros" },
          ];
          this.itemsDetail = res.data.data.vehiculodb;

          for (let i = 0; i < this.itemsDetail.length; i++) {
            this.itemsDetail[i].nombre =
              this.itemsDetail[i].nombre + " " + this.itemsDetail[i].apellido_paterno + " " + this.itemsDetail[i].apellido_materno;
          }
          this.sheets = [
            {
              name: "Reporte de vehiculos",
              data: [{}],
            },
          ];
          if (this.itemsDetail.length > 0) {
            this.sheets[0].data.shift();
          }
          for (let i = 0; i < this.itemsDetail.length; i++) {
            let obj = {
              Placas: this.itemsDetail[i].placas,
              "Número económico": this.itemsDetail[i].numero_economico,
              Capacidad: this.itemsDetail[i].capacidad,
              Marca: this.itemsDetail[i].marca_chasis,
              Modelo: this.itemsDetail[i].marca_carroceria,
              Año: this.itemsDetail[i].modelo_chasis,
              "Número de viajes": this.itemsDetail[i].cantidad_viajes,
              "Calificación promedio": this.itemsDetail[i].promedio_calificacion,
              "Nombre del operador": this.itemsDetail[i].nombre,
              "Número máximo de pasajeros": this.itemsDetail[i].max_pasajeros,
            };
            this.sheets[0].data.push(obj);
          }
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.message;
        })
        .finally(() => {
          this.loadingReports = false;
        });
    },
    reportViajes() {
      let data;
      if (this.allRoutesSelected) {
        for (let i = 0; i < this.state.length; i++) {
          this.state[i] = this.state[i];
        }
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      } else {
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      }
      this.reportType = "Viajes";
      this.loadingReports = true;
      this.axios
        .post(services.routes.van + "/report/for/download", { data })
        .then((res) => {
          this.headersDetail = [
            { text: "Folio de viaje", align: "center", sortable: false, value: "folio_orden_servicio" },
            { text: "Estado de viaje", align: "center", sortable: false, value: "estado_externo" },
            { text: "Ruta", align: "center", sortable: false, value: "nombre_ruta" },
            { text: "Tipo de servicio", align: "center", sortable: false, value: "tipo_viaje" },
            { text: "Fecha Hora Inicio", align: "center", sortable: false, value: "fecha_inicio_plan" },
            { text: "Fecha Hora Fin", align: "center", sortable: false, value: "fecha_fin_plan" },
            { text: "Número económico", align: "center", sortable: false, value: "numero_economico" },
            { text: "Nombre del operador", align: "center", sortable: false, value: "conductor_nombre" },
            { text: "Turno", align: "center", sortable: false, value: "turno_id" },
            { text: "Placas", align: "center", sortable: false, value: "placas" },
            { text: "Capacidad", align: "center", sortable: false, value: "capacidad" },
            { text: "Marca", align: "center", sortable: false, value: "marca_chasis" },
            { text: "Modelo", align: "center", sortable: false, value: "modelo_carroceria" },
            { text: "Año", align: "center", sortable: false, value: "modelo_chasis" },
            { text: "Promedio de calificaciones", align: "center", sortable: false, value: "promedio_calificaciones" },
            { text: "Ocupación mínima", align: "center", sortable: false, value: "pasajeros_minimos" },
            { text: "Ocupación máxima ", align: "center", sortable: false, value: "pasajeros_maximos" },
            { text: "Pasajeros totales en el viaje", align: "center", sortable: false, value: "pasajeros_totales" },
          ];
          this.itemsDetail = res.data.data;
          for (let i = 0; i < this.itemsDetail.length; i++) {
            if (this.itemsDetail[i].estado == true) {
              this.itemsDetail[i].estado = "Activo";
            } else {
              this.itemsDetail[i].estado = "Inactivo";
            }
            const estado_externo = _.get(this.itemsDetail[i], "estado_externo", "").toString();
            if (_.has(this.estados_viaje, estado_externo)) {
              this.itemsDetail[i].estado_externo = this.estados_viaje[estado_externo];
            } else {
              this.itemsDetail[i].estado_externo = "";
            }
            this.itemsDetail[i].fecha_inicio_plan = moment(this.itemsDetail[i].fecha_inicio_plan).format("DD-MM-YYYY HH:mm");
            this.itemsDetail[i].fecha_fin_plan = moment(this.itemsDetail[i].fecha_fin_plan).format("DD-MM-YYYY HH:mm");
            this.itemsDetail[i].conductor_nombre =
              this.itemsDetail[i].conductor_nombre +
              " " +
              this.itemsDetail[i].conductor_apellido_paterno +
              " " +
              this.itemsDetail[i].conductor_apellido_materno;
          }
          this.sheets = [
            {
              name: "Reporte de viaje",
              data: [{}],
            },
          ];
          if (this.itemsDetail.length > 0) {
            this.sheets[0].data.shift();
          }
          for (let i = 0; i < this.itemsDetail.length; i++) {
            let obj = {
              "Folio de viaje": this.itemsDetail[i].folio_orden_servicio,
              "Estado de viaje": this.itemsDetail[i].estado_externo,
              Ruta: this.itemsDetail[i].nombre_ruta,
              "Tipo de servicio": this.itemsDetail[i].tipo_viaje,
              "Fecha Hora Inicio": this.itemsDetail[i].fecha_inicio_plan,
              "Fecha Hora Fin": this.itemsDetail[i].fecha_fin_plan,
              "Número económico": this.itemsDetail[i].numero_economico,
              "Nombre del operador": this.itemsDetail[i].conductor_nombre,
              Turno: this.itemsDetail[i].turno_id,
              Placas: this.itemsDetail[i].placas,
              Capacidad: this.itemsDetail[i].capacidad,
              Marca: this.itemsDetail[i].marca_chasis,
              Modelo: this.itemsDetail[i].modelo_chasis,
              Año: this.itemsDetail[i].modelo_chasis,
              "Promedio de calificaciones": this.itemsDetail[i].promedio_calificaciones,
              "Ocupación mínima": this.itemsDetail[i].pasajeros_minimos,
              "Ocupación máxima": this.itemsDetail[i].pasajeros_maximos,
              "Pasajeros totales en el viaje": this.itemsDetail[i].pasajeros_totales,
            };
            this.sheets[0].data.push(obj);
          }
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loadingReports = false;
        });
    },
    reportUtilizacion() {
      let data;
      if (this.allRoutesSelected) {
        for (let i = 0; i < this.state.length; i++) {
          this.state[i] = this.state[i];
        }
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      } else {
        data = {
          fecha_inicio: moment(this.date + "T00:00:00"),
          fecha_fin: moment(this.date2 + "T23:59:59"),
          rutas: this.state == "" ? [] : this.state,
        };
      }
      this.reportType = "Utilización";
      this.loadingReports = true;
      this.axios
        .post(services.routes.van + "/report/transaction/summary", { data })
        .then((res) => {
          this.headersDetail = [
            { text: "Nombre de ruta", align: "center", sortable: false, value: "nombre_ruta_van" },
            { text: "Días de operación", align: "center", sortable: false, value: "dias_operacion" },
            { text: "Tiempo de traslado (min)", align: "center", sortable: false, value: "tiempo_traslado_minutos" },
            { text: "Total de usuarios en periodo", align: "center", sortable: false, value: "usuarios_periodo" },
            { text: "Promedio diario", align: "center", sortable: false, value: "promedio_diario" },
            { text: "Capacidad", align: "center", sortable: false, value: "capacidad" },
            { text: "Modelo", align: "center", sortable: false, value: "modelo_carroceria" },
            { text: "Utilización", align: "center", sortable: false, value: "utilizacion" },
          ];
          this.itemsDetail = res.data.data;
          for (let i = 0; i < this.itemsDetail.length; i++) {
            this.itemsDetail[i].utilizacion = this.itemsDetail[i].utilizacion + " %";
          }
          this.sheets = [
            {
              name: "Reporte de utilización",
              data: [{}],
            },
          ];
          if (this.itemsDetail.length > 0) {
            this.sheets[0].data.shift();
          }
          for (let i = 0; i < this.itemsDetail.length; i++) {
            let obj = {
              "Nombre de ruta": this.itemsDetail[i].nombre_ruta_van,
              "Días de operación": this.itemsDetail[i].dias_operacion,
              "Tiempo de traslado (min)": this.itemsDetail[i].tiempo_traslado_minutos,
              "Total de usuarios en periodo": this.itemsDetail[i].usuarios_periodo,
              "Promedio diario": this.itemsDetail[i].promedio_diario,
              Capacidad: this.itemsDetail[i].capacidad,
              Modelo: this.itemsDetail[i].modelo_carroceria,
              Utilización: this.itemsDetail[i].utilizacion,
            };
            this.sheets[0].data.push(obj);
          }
        })
        .catch((error) => {
          this.error = true;
          this.codeError = error.response.data.code;
        })
        .finally(() => {
          this.loadingReports = false;
        });
    },
    clean() {
      this.searchRoutes = "";
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allRoutes) {
          this.allRoutesSelected = false;
          this.state = [];
        } else {
          this.allRoutesSelected = true;
          this.state = this.routes.slice();
        }
      });
    },
    openTransactions() {
      this.dialogs.transactions = true;
      this.getTransactions();
    },
    openDialogAddPassangers(item) {
      this.valor_porc = 0;
      this.valor_cant = 0;
      this.dialogs.addPassengers = true;
      this.selectedTrip = item;
    },
    getTransactions() {
      this.date3 = !this.date3 ? this.date : this.date3;
      this.date4 = !this.date4 ? this.date2 : this.date4;
      if (this.date3 && this.date4) {
        this.loadingReports = true;
        let data = {
          fecha_inicio: moment(this.date3 + "T00:00:00"),
          fecha_fin: moment(this.date4 + "T23:59:59"),
        };
        this.reportType = "Transacciones";
        this.axios
          .post(services.routes.van + "/report/transaction/trip/van", { data })
          .then((res) => {
            this.headersTransactions = [
              { text: "Estado de transacción", align: "center", sortable: false, value: "ts_nombre" },
              { text: "Folio de viaje", align: "center", sortable: false, value: "folio_viaje" },
              { text: "Id viaje", align: "center", sortable: false, value: "idviaje_usuario_van" },
              { text: "Kilómetros", align: "center", sortable: false, value: "kilometros" },
              { text: "Costo total", align: "center", sortable: false, value: "costo_total" },
              { text: "Código de boleto", align: "center", sortable: false, value: "codigo_boleto" },
              { text: "Fecha de reservación", align: "center", sortable: false, value: "fecha_reservacion" },
              { text: "Nombre del usuario", align: "center", sortable: false, value: "nombre_usuario" },
              { text: "Número de nomina", align: "center", sortable: false, value: "numero_nomina_usuario" },
              { text: "Email", align: "center", sortable: false, value: "email" },
              { text: "Id ruta", align: "center", sortable: false, value: "idruta" },
              { text: "Nombre de ruta", align: "center", sortable: false, value: "nombre_ruta" },
              { text: "Nombre", align: "center", sortable: false, value: "nombre" },
              { text: "Nombre del operador", align: "center", sortable: false, value: "nombre_operador" },
              { text: "Número económico", align: "center", sortable: false, value: "numero_economico" },
              { text: "Modelo", align: "center", sortable: false, value: "modelo_carroceria" },
              { text: "Parada inicio", align: "center", sortable: false, value: "nombre_parada_inicio" },
              { text: "Parada fin", align: "center", sortable: false, value: "nombre_parada_final" },
              { text: "Fecha de viaje", align: "center", sortable: false, value: "fecha_viaje" },
              { text: "Hora inicio programada", align: "center", sortable: false, value: "hora_inicio_programada" },
              { text: "Hora fin programada", align: "center", sortable: false, value: "hora_fin_programada" },
              { text: "Hora inicio real", align: "center", sortable: false, value: "hora_inicio_real" },
              { text: "Hora fin real", align: "center", sortable: false, value: "hora_fin_real" },
            ];
            this.itemsTransactions = res.data.data;
            for (let i = 0; i < this.itemsTransactions.length; i++) {
              this.itemsTransactions[i].ts_nombre =
                this.itemsTransactions[i].desc_cambio_estado == "AUTOMATIC_FINISHED"
                  ? this.itemsTransactions[i].estado + " Automatico"
                  : this.itemsTransactions[i].estado;
              this.itemsTransactions[i].fecha_reservacion = moment(this.itemsTransactions[i].fecha_reservacion).format("DD-MM-YYYY HH:mm");
              this.itemsTransactions[i].fecha_viaje = moment(this.itemsTransactions[i].fecha_viaje).format("DD-MM-YYYY HH:mm");
              this.itemsTransactions[i].hora_inicio_programada = moment(
                moment().format("YYYY-MM-DD") + "T" + this.itemsTransactions[i].hora_inicio_programada + ".000Z"
              ).format("HH:mm");
              this.itemsTransactions[i].hora_fin_programada = moment(
                moment().format("YYYY-MM-DD") + "T" + this.itemsTransactions[i].hora_fin_programada + ".000Z"
              ).format("HH:mm");
              this.itemsTransactions[i].hora_inicio_real = this.itemsTransactions[i].hora_inicio_real
                ? moment(this.itemsTransactions[i].hora_inicio_real).format("HH:mm")
                : "";
              this.itemsTransactions[i].hora_fin_real = this.itemsTransactions[i].hora_fin_real
                ? moment(this.itemsTransactions[i].hora_fin_real).format("HH:mm")
                : "";
            }
            this.sheets = [
              {
                name: "Reporte de transacciones",
                data: [{}],
              },
            ];
            if (this.itemsTransactions.length > 0) {
              this.sheets[0].data.shift();
            }
            for (let i = 0; i < this.itemsTransactions.length; i++) {
              let obj = {
                "Estado de transacción": this.itemsTransactions[i].ts_nombre,
                "Folio de viaje": this.itemsTransactions[i].folio_viaje,
                "Id viaje": this.itemsTransactions[i].idviaje_usuario_van,
                Kilómetros: this.itemsTransactions[i].kilometros,
                "Costo total": this.itemsTransactions[i].costo_total,
                "Código de boleto": this.itemsTransactions[i].codigo_boleto,
                "Fecha de reservación": this.itemsTransactions[i].fecha_reservacion,
                "Número de empleado": this.itemsTransactions[i].numero_nomina_usuario,
                "Email": this.itemsTransactions[i].email,
                "Nombre del usuario": this.itemsTransactions[i].nombre_usuario,
                "Id ruta": this.itemsTransactions[i].idruta,
                "Nombre de ruta": this.itemsTransactions[i].nombre_ruta,
                Nombre: this.itemsTransactions[i].nombre,
                "Nombre del operador": this.itemsTransactions[i].nombre_operador,
                "Número económico": this.itemsTransactions[i].numero_economico,
                Modelo: this.itemsTransactions[i].modelo_carroceria,
                "Parada inicio": this.itemsTransactions[i].nombre_parada_inicio,
                "Parada fin": this.itemsTransactions[i].nombre_parada_final,
                "Fecha de viaje": this.itemsTransactions[i].fecha_viaje,
                "Hora inicio programada": this.itemsTransactions[i].hora_inicio_programada,
                "Hora fin programada": this.itemsTransactions[i].hora_fin_programada,
                "Hora inicio real": this.itemsTransactions[i].hora_inicio_real,
                "Hora fin real": this.itemsTransactions[i].hora_fin_real,
              };
              this.sheets[0].data.push(obj);
            }
            this.loadingReports = false;
          })
          .catch((error) => {
            this.error = true;
            this.codeError = error.response.data.code;
            this.loadingReports = false;
          })
          .finally(() => {
          });
      }
    },
  },
};
</script>

<style scoped>
.v-application--is-ltr .v-btn-toggle > .v-btn.v-btn:not(:first-child) {
  border-left-width: 1;
}
</style>
